var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 360,
    viewBox: "0 0 423 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M115.47 7.79055L81.0721 101.423C120.569 61.5287 202.126 57.3313 237.968 60.2194L343.408 72.551C320.683 35.4467 266.117 21.5197 241.675 19.1943L115.47 7.79055Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.744 234.99C136.514 219.438 145.706 202.018 149.706 195.253C165.059 205.333 187.589 213.047 196.935 215.644C247.411 234.225 307.09 219.756 330.62 210.198C296.133 256.714 224.174 265.891 192.505 264.665C168.763 263.642 136.72 260.092 123.666 258.445L131.744 234.99Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4985 162.305L2.41033e-05 323.681L77.5306 330.687L119.567 218.466C122.948 205.873 135.498 184.388 141.351 175.219C176.914 107.489 264.787 113.817 304.278 125.447C206.758 124.767 171.127 163.772 165.501 183.36C221.273 220.927 298.728 204.979 330.484 192.309C403.66 154.406 416.223 107.171 417.878 90.1461C401.601 99.6111 328.099 89.3943 293.383 83.1028C233.177 72.8957 180.941 78.4339 162.349 82.479C96.7173 91.9709 67.1021 139.651 60.4985 162.305ZM90.2247 194.085C99.9217 164.35 137.867 103.612 212.073 98.54C184.769 103.317 122.173 129.113 90.2247 194.085ZM214.108 180.742C241.939 176.597 304.779 163.348 333.491 143.51C315.536 157.31 266.524 184.076 214.108 180.742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlue);
export default __webpack_public_path__ + "static/media/bg_blue.1ae66beaee333a29abfacf7c3cb762e4.svg";
export { ForwardRef as ReactComponent };